<div class="wrapper__headerComponent container mt-3 mt-md-5">
    <div class="row">
        <div class="d-flex flex-row align-items-center align-items-md-start">
            <img src="../../../../assets/img/file-alt.svg" alt="logo" class="img-ico-form" />
            <h2 class="mb-0">{{ "crear-empresa.titulo" | translate }}</h2>
        </div>
    </div>
</div>

<div class="container wrapper__headerComponent d-flex flex-column gap-2">
    <div class="border__form rounded px-3 py-4">

        <!-- PASOS -->
        <div class="pasos-container">
            <div class="paso" [class.activo]="pasoActual === 1">{{ "crear-empresa.paso_uno"| translate }}</div>
            <div class="paso" [class.activo]="pasoActual === 2">{{ "crear-empresa.paso_dos"| translate }}</div>
        </div>

        <!-- PASO 1 – ESTABLECER CONTRASEÑA -->
        <div *ngIf="pasoActual === 1" class="paso-content">

            <app-form 
                *ngIf="formFieldsPaso1.length>0"
                [title]="empresaText['password-titulo']"
                [fields]="formFieldsPaso1" 
                [withSubmitButton]="false"
                (changeAction)="validarFormularioPaso1($event)"
                (changedControl)="onChangePaso1($event)">
            </app-form>

            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
                <div class="d-flex flex-column flex-md-row gap-2">
                    <button type="button" class="btn-govco fill-btn-govco w-auto"  
                        (click)="continuarPaso2()"
                        aria-label="Continuar al paso 2">
                        {{ 'tramites.botones-envio.enviar'| translate }}
                    </button>
                </div>
            </div>

        </div>

        <!-- PASO 2 – DATOS OBSERVATORIO EMPRESA -->
        <div *ngIf="pasoActual === 2" class="paso-content">

            <app-form
                *ngIf="formFieldsPaso2.length>0" 
                [title]="empresaText['titulo-observatorio']"
                [fields]="formFieldsPaso2" 
                [withSubmitButton]="false"
                (changeAction)="validarFormularioPaso2($event)"
                (changedControl)="onChangePaso2($event)">
            </app-form>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
                <div class="d-flex flex-column flex-md-row gap-2">
                    <button type="button" class="btn-govco fill-btn-govco w-auto" 
                        (click)="guardarFormulario()"
                        aria-label="Enviar formulario">
                        {{ 'tramites.botones-envio.enviar'| translate }}
                    </button>
                </div>
            </div>

        </div>

    </div>
    <div class="mt-4 text-muted small text-center">
    </div>
</div>